import Header from "../components/Header";

export default function Journal() {
  return (
    <>
      <Header />
      <h1>Journal Page WIP</h1>
    </>
  );
}
